import './dialog.css'

import React, { useEffect, useRef, useState } from 'react'
import { Spinner } from '@/components/spinner'
import { useAppContext } from '@/context/app'

export const MainDialogPopup = ({ key, onClose, onOK }: {
  key: string
  onClose: () => void,
  onOK: () => void
}) => {
  const { translates } = useAppContext()
  const [isLoading, setLoading] = useState<boolean>(false)

  if(!translates || isLoading) {
    return <Spinner />
  }

  return <div className='main-dialog'>
    <div className='dialog-text'>{translates.for(`${key}.title`)}</div>
    <div className='dialog-btns'>
      <div className='dialog-btn' onClick={onClose}>
        <i className='svgfont-no' />
        {translates.for(`elements.dialog.yesno.no`)}
      </div>
      <div className='dialog-btn' onClick={() => {
        setLoading(true)
        onOK()
      }}>
        <i className='svgfont-yes' />
        {translates.for(`elements.dialog.yesno.yes`)}
      </div>
    </div>
  </div>
}